module.exports = __webpack_public_path__ + "svg/logo_mc.a912eca69bf76cf29d36ce259d65e89a.svg";